import * as React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

const CircleContainer = (props: any) => {
    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            circle1: {
                position: "relative",
                width: props.size,
                height: props.size,
                background: "linear-gradient(150deg, rgba(107,110,115,1) 0%, rgba(156,166,176,1) 100%);",
                borderRadius: "50%",
                boxShadow: "5px 5px 40px ",
            },
            circle: {
                position: "absolute",
                top: props.size * 0.05,
                left: props.size * 0.05,
                width: props.size - props.size * 0.1,
                height: props.size - props.size * 0.1,
                background: "linear-gradient(150deg, rgba(156,166,176,1) 0%, rgba(107,110,115,1) 100%);",
                borderRadius: "50%",
            },
            circle3: {
                position: "absolute",
                top: (props.size * 0.8) / 4,
                left: (props.size * 0.8) / 4,
                width: (props.size * 0.8) / 2,
                height: (props.size * 0.8) / 2,
                background: "linear-gradient(150deg, rgba(100,100,100,1) 0%, rgba(40,40,40,1) 100%);",
                borderRadius: "50%",
            },
        })
    );
    var classes = useStyles();
    return (
        <Grid container direction="column" alignContent="center" spacing={1}>
            <Grid item className={classes.circle1}>
                <Grid className={classes.circle} container alignContent="center" justify="center">
                    <Grid item style={{ textAlign: "left" }}>
                        {props.children}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default CircleContainer;
